export enum AvailableVehicleUsageType {
  MILEAGE = 'Przebieg w kilometrach',
  MOTO_HOURS = 'Przebieg w motogodzinach',
  BOTH = 'Przebieg w kilometrach lub motogodzinach'
}
